import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

import CardBody from "beaktShared/components/Card/CardBody.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import InputAdornment from '@material-ui/core/InputAdornment';
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import Select from 'react-select';
import CircularProgress from '@material-ui/core/CircularProgress';

// services
import { MaskDate, formateDate, validateDate, convertDate, MaskTime, MaskCPF, MaskCel } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePutApi } from "beaktShared/services/crudeApiService";

// style
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { isJSDocReturnTag } from "typescript";
const useStyles = makeStyles(styles);

export default function EditarAgendamento({ item, callback, closemodal, showmodal }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);

    const { register, handleSubmit, setValue, getValues, errors, clearError, setError } = useForm({ mode: "onChange" });


    const [loading, setLoading] = React.useState(false);
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };
    const intialValues = {
        cliente: '',
        profissional: '',
        servico: '',
        idcliente: 0
    };


    const [agendamentoId, setagendamentoId] = React.useState(0);

    useEffect(() => {
        loadProfissionais();
        LoadServicos();
        LoadDadosItem();
    }, [item]);

    const LoadDadosItem = () => {
        setValue("nomecliente", item.nomeCliente);
        setValue("emailcliente", item.emailCliente);
        setValue("cpfcliente", item.cpfCliente);
        setValue("celularcliente", item.celularCliente);
        setValue("data", item.dataF);
        setValue("hora", item.horaInicio);
        setValue("duracao", item.tempoDuracao);
        setValue("obs", item.obs);
        setValue("idcliente", item.clienteId);

        setagendamentoId(item.agendamentoId);
    }

    const [profissionaisLoading, setprofissionaisLoading] = React.useState(false);
    const [profissional, setprofissional] = React.useState("");
    const [listSelectProfissional, setlistSelectProfissional] = React.useState([]);
    //carrega profissionais do estabelecimento
    const loadProfissionais = () => {

        setprofissionaisLoading(true);
        const endPoint = "profissionais/agenda/" + session.estabelecimentoId
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setprofissionaisLoading(false);
                return false;
            }

            let lstProfissionais = [];
            result.data.map(item => {

                var p = {
                    id: item.profissionalId,
                    title: item.nome,
                    especialidade: item.profissionalEspecialidades,
                    servicos: item.profissionalServicos
                }

                if (session && session.tipoPerfil === 2) {// Perfil Profissional só vê a agenda dele
                    if (item.usuarioId === session.id)
                        lstProfissionais.push(p);
                }
                else if (session && session.tipoPerfil !== 2) {
                    lstProfissionais.push(p);
                }
                else {
                    lstProfissionais.push(p);
                }

            });

            setlistSelectProfissional(lstProfissionais);
            setprofissionaisLoading(false);

            return true;
        });
        return true;
    }

    const [servicos, setservicos] = React.useState([]);
    const [servico, setservico] = React.useState("");
    const [listSelectServico, setlistSelectServico] = React.useState([]);
    //carrega todos serviços ativos do estabelecimento
    const LoadServicos = () => {

        const endPoint = "servicos/ativos/byestabelecimento/" + session.estabelecimentoId
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }

            setservicos(result.data);
            return true;
        });
    };
    // handle para selecionar profissional
    const handleProfissionalChange = event => {
        let value = event
        setprofissional(value);
        setValue("profissional", value);
        loadServicosbyProfissional(value)
        if (value !== "")
            clearError("profissional");

        setservico(null);
        setValue("servico", null);
    };

    //handle para selecionar serviço
    const handleServicoChange = event => {
        let value = event
        setservico(value);
        setValue("servico", value);
        if (value !== "")
            clearError("servico");

        var vefifyExists = listSelectServico.filter(obj => {
            return obj.servicoId === value;
        });

        if (vefifyExists.length > 0)
            setValue("duracao", vefifyExists[0].tempoExecucao);
        else
            setValue("duracao", "");

    };

    // metodo para filtrar somente os serviços do profissional selecionado no handleProfissionalChange
    const loadServicosbyProfissional = (idprofissional) => {

        var profissionalSelecionado = listSelectProfissional.filter(obj => {
            return obj.id === idprofissional;
        });

        if (profissionalSelecionado[0].servicos === null)
            return;

        var idsServicos = [];
        profissionalSelecionado[0].servicos.map(item => {
            idsServicos.push(item.servicoId);
            return true;
        })

        var servicoFiltered = [];
        idsServicos.map(id => {

            var servicobyProfissional = servicos.filter(obj => {
                return obj.servicoId === id;
            });
            if (servicobyProfissional !== null)
                servicoFiltered.push(...servicobyProfissional);

        })

        setlistSelectServico(servicoFiltered);

    }

    const hideModal = () => {
        closemodal();

    }

    const onSubmit = data => {

        if (!validateDate(data.data)) {
            return setError("data", "invaliddate", t('error_message.invalid_date'))
        }

        var dataC = convertDate(data.data);

        var obj = {
            agendamentoId: agendamentoId,
            data: dataC,
            horaInicio: data.hora,
            horaFim: "00:00:00",
            tempoDuracao: parseInt(data.duracao),
            servicoId: data.servico,
            profissionalId: data.profissional,
            obs: data.obs,
            statusAgendamento: 0,
            usuarioCadastroId: session.id,
            estabelecimentoId: session.estabelecimentoId,
            clienteId: parseInt(data.idcliente),
            cpfcliente: data.cpfcliente,
            emailcliente: data.emailcliente,
            nomecliente: data.nomecliente,
            celularcliente: data.celularcliente,
        }

        let endPoint = 'agendamentos/';
         setLoading(true);
        UsePutApi(endPoint, agendamentoId,obj).then(result => {
            if (result.status !== 200) {
                showNotification(result.message.message, 'danger');
                setLoading(false);
                return false;
            }

            setLoading(false);
            closemodal();
            callback();
            return true;
        });

    };

    const onlyNumbers = (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') };

    return (
        <CardBody>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }

            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <h3 style={{ marginTop: '5px', marginBottom: '3px' }}>{t('agenda.edit_schedules')}</h3>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        <br />
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.data ? true : false}
                                label={t('label.date') + " *"}
                                variant="outlined"
                                inputRef={register({ required: t('label.required') })}
                                name="data"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskDate,
                                }}
                            />
                            {errors.data && <FormHelperText className={classes.labelRootError}>
                                <span>{errors.data.message}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        <br />
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.hora ? true : false}
                                label={t('agenda.start_time') + " *"}
                                variant="outlined"
                                inputRef={register({ required: true })}
                                name="hora"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskTime,
                                }}
                            />
                            {errors.hora && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>

                <GridContainer>
                    <input className={classes.hidden} defaultValue={intialValues.idcliente} name="idcliente" ref={register} />
                    <GridItem xs={12} sm={4} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                label="CPF"
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="cpfcliente"
                                defaultValue={intialValues.cpf}
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={8} md={8}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                label={t('label.client_email') + " *"}
                                variant="outlined"
                                inputRef={register({ required: true })}
                                name="emailcliente"
                                defaultValue={intialValues.emailcliente}
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.nomecliente ? true : false}
                                label={t('label.client_name') + " *"}
                                variant="outlined"
                                inputRef={register({ required: true })}
                                name="nomecliente"
                                defaultValue={intialValues.nomecliente}
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 100 }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={4} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.celularcliente ? true : false}
                                label={t('label.cell_phone')}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="celularcliente"
                                defaultValue={intialValues.celularcliente}
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ inputComponent: MaskCel }}
                            />
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={5} md={5}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.profissional ? "select__label select__label_error" : "select__label"}>
                                {t('label.professional')} *</label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.profissional ? true : false)}
                                isSearchable={true}
                                name="profissional"
                                placeholder="Selecione..."
                                options={listSelectProfissional}
                                value={listSelectProfissional.filter(({ id }) => id === profissional)}
                                getOptionLabel={({ title }) => title}
                                getOptionValue={({ id }) => id}
                                onChange={(value) => handleProfissionalChange(value.id !== null ? value.id : "")}

                                ref={() => register(
                                    { name: "profissional" },
                                    { required: true })
                                }
                            />
                            {errors.profissional && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={5}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.servico ? "select__label select__label_error" : "select__label"}>
                                {t('label.service')}  *</label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.servico ? true : false)}
                                isSearchable={true}
                                name="servico"
                                placeholder="Selecione..."
                                options={listSelectServico}
                                value={listSelectServico.filter(({ servicoId }) => servicoId === servico)}
                                getOptionLabel={({ descricao }) => descricao}
                                getOptionValue={({ servicoId }) => servicoId}
                                onChange={(value) => handleServicoChange(value.servicoId !== null ? value.servicoId : "")}
                                ref={() => register(
                                    { name: "servico" },
                                    { required: true })
                                }
                            />
                            {errors.servico && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={2}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.duracao ? true : false}
                                label={t('label.duration_minutes') + " *"}
                                variant="outlined"
                                name="duracao"
                                inputRef={register({ required: true })}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 3 }}
                                onInput={(e) => onlyNumbers(e)}
                            />
                            {errors.duracao && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.obs ? true : false}
                                label={t('label.obs') + " *"}
                                variant="outlined"
                                inputRef={register}
                                name="obs"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rowsMax="3"
                                rows="2"
                                inputProps={{ maxLength: 500 }}
                            />
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <div className={classes.textCenter}>
                            <Button onClick={hideModal} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}  {loading && <div> ... {t('label.loading')}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </CardBody>
    );
}
